import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { fetchUserByEmail, logout, SESSION_ENDED_EVENT } from '../../../store/actions/userActions';

export const useAuthSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('myEmail');

  // The server refused this session mid-use (the account was locked or
  // deleted, or the token died): sign out and land on the login page with
  // the server's plain message, never a raw "HTTP 401" or an endless spinner.
  useEffect(() => {
    const onSessionEnded = (event) => {
      const { message, cleared } = event.detail || {};
      if (!cleared) {
        // A late answer after the user already logged out: nothing to end.
        if (!localStorage.getItem('token')) return;
        dispatch(logout());
      }
      toast.error(message, { id: 'session-ended', duration: 10000 });
      navigate('/login', { replace: true, state: { sessionEnded: message } });
    };
    window.addEventListener(SESSION_ENDED_EVENT, onSessionEnded);
    return () => window.removeEventListener(SESSION_ENDED_EVENT, onSessionEnded);
  }, [dispatch, navigate]);

  useEffect(() => {
    if (token && email && (!user?.email || user?.email !== email)) {
      dispatch(fetchUserByEmail(email));
    }
  }, [token, email, user?.email, dispatch]);

  return { user };
};
